/* eslint-disable react-hooks/rules-of-hooks */
import styled from '@emotion/styled'
import { ButtonBase, ButtonBaseProps } from '@mui/material'
import chroma from 'chroma-js'
import { FC } from 'react'
import { Colors, Shapes, Typographies, themeSpacing, useTypography } from 'src/components/theme'
import { rgbaStrOpacity } from 'src/utils/colors'

export type ButtonWithIconProps = {
  inverted?: boolean
  disabled?: boolean
  active?: boolean
  color?: string
  ghost?: boolean
  fullWidth?: boolean
  href?: string
}

export const ButtonWithIconStyled = styled(ButtonBase)<
  Omit<ButtonWithIconProps, 'ghost' | 'inverted' | 'active'> & {
    ghost?: 1 | 0 // getting Warning: Received `true` for a non-boolean attribute if we use boolean
    inverted?: 1 | 0
    active?: 1 | 0
  }
>`
  display: flex;
  gap: ${Shapes.spacing[2]}px;
  background-color: ${(props) =>
    props.disabled
      ? `${Colors.bgWhite}`
      : props.inverted || props.active
        ? props.color || Colors.primaryBlue400
        : props.ghost
          ? 'transparent'
          : Colors.bgWhite};
  color: ${(props) =>
    props.disabled
      ? props.inverted || props.active
        ? `${Colors.textWhite} !important`
        : `${Colors.textDisabled} !important`
      : props.color || Colors.primaryBlue400};
  -webkit-text-fill-color: ${(props) =>
    props.disabled
      ? props.inverted || props.active
        ? `${Colors.textWhite} !important`
        : `${Colors.textDisabled} !important`
      : props.inverted || props.active
        ? `${Colors.textWhite} !important`
        : props.color || Colors.primaryBlue400};
  svg {
    color: ${(props) =>
      props.inverted || props.active ? Colors.textWhite : props.color || Colors.primaryBlue400} !important;
    fill: ${(props) =>
      props.inverted || props.active ? Colors.textWhite : props.color || Colors.primaryBlue400} !important;
  }

  box-shadow: none;
  text-transform: unset;
  border: 1px solid;
  border-color: ${(props) =>
    props.ghost === 1 ? 'transparent' : props.disabled ? Colors.bgDark : props.color || Colors.primaryBlue400};
  border-radius: ${Shapes.borderRadius}px;
  box-shadow: none;
  padding: ${Shapes.spacing[1]}px ${Shapes.spacing[2]}px;
  width: ${(props) => (props.fullWidth ? '100%' : 'fit-content')};
  ${useTypography(Typographies.textmd)}
  & > img {
    border-radius: 50%;
    margin-right: ${themeSpacing(2)}px;
  }
  &:hover {
    background-color: ${(props) =>
      props.inverted || props.active
        ? props.color || Colors.primaryBlue400
        : !props.inverted
          ? chroma(props.color || Colors.primaryBlue400)
              .luminance(0.95)
              .hex()
          : Colors.bgWhite};
    box-shadow: ${(props) => (props.inverted ? Colors.BOX_SHADOW : 'none')};
  }
  &:disabled {
    border-color: ${(props) =>
      props.ghost === 1 || props.inverted !== 1
        ? 'transparent'
        : rgbaStrOpacity(props.color || Colors.primaryBlue400, 0.6)};
    background-color: ${(props) =>
      props.inverted || props.active
        ? chroma(props.color || Colors.primaryBlue400)
            .brighten(0.75)
            .hex()
        : Colors.bgLight};
    color: ${(props) =>
      props.inverted || props.active
        ? Colors.textWhite
        : rgbaStrOpacity(props.color || Colors.primaryBlue400, 0.6)} !important;
    svg {
      color: ${(props) =>
        props.inverted || props.active
          ? Colors.textWhite
          : rgbaStrOpacity(props.color || Colors.primaryBlue400, 0.6)} !important;
      fill: ${(props) =>
        props.inverted || props.active
          ? Colors.textWhite
          : rgbaStrOpacity(props.color || Colors.primaryBlue400, 0.6)} !important;
    }
  }
`

export const ButtonWithIcon: FC<ButtonWithIconProps & ButtonBaseProps> = (
  props: ButtonWithIconProps & ButtonBaseProps
) => {
  return (
    <ButtonWithIconStyled
      {...props}
      ghost={props.ghost ? 1 : 0}
      inverted={props.inverted ? 1 : 0}
      active={props.active ? 1 : 0}
      className={`button-with-icon ${props.className || ''}`}
    />
  )
}
